import React, { useState, useEffect, useRef } from "react";
import ButtonFilter from "./Filters/ButtonFilter";
import "../styles/filters.css";

const FilterMenu = ({ dataElements = [], dataLabelProp, groupOptionsLabel = undefined, defaultElements = [], onSelect = (baskets) => {}, onClear = () => {} }) => {
    const [initialOptions, setInitialOptions] = useState({});
    const [options, setOptions] = useState(initialOptions);

    const [isOpenFilter, setOpenFilter] = useState(false);
    const [searchQuery, setSearchQuery] = useState(undefined);

    const ref = useRef(null);
    // const selectedElements = Object.keys(options)
    //     .map((option) => Object.values(option)[0])
    //     .reduce((acc, baskets) => {
    //         const selectedBaskets = baskets.filter((basket) => basket.checked);
    //         return [...acc, ...selectedBaskets];
    //     }, []);

    const selectedElements = Object.values(initialOptions)
        .filter((baskets) => baskets.filter((basket) => basket.checked).length > 0)
        .reduce((acc, baskets) => {
            return [...acc, ...baskets.filter((basket) => basket.checked)];
        }, []);

    const groupOptions = (data, categoryLabel) => {
        return data.reduce((acc, nextValue) => {
            let obj = {
                ...nextValue,
                checked: defaultElements.find((defaultEement) => defaultEement.id === nextValue.id) !== undefined,
            };
            const categoryValue = obj[categoryLabel] || "My baskets";
            if (!acc[categoryValue]) {
                acc[categoryValue] = [obj];
            } else {
                acc[categoryValue] = [...acc[categoryValue], obj];
            }
            return acc;
        }, {});
    };

    // let result = groupOptions(dataElements, 'group');

    useEffect(() => {
        if (dataElements?.length > 0) {
            let newOptions = {};
            if (groupOptionsLabel) {
                newOptions = groupOptions(dataElements, groupOptionsLabel);
            } else {
                newOptions = dataElements.map((elem) =>
                    Object.assign({
                        ...elem,
                        checked: defaultElements.find((defaultEement) => defaultEement.id === elem.id) !== undefined,
                    }),
                );
            }
            setOptions(newOptions);
            setInitialOptions(newOptions);
        }
    }, [dataElements]);

    useEffect(() => {
        isOpenFilter && document.addEventListener("mousedown", clickHandleOutside);
    }, [isOpenFilter]);

    useEffect(() => {
        let newOptions = initialOptions;
        if (searchQuery?.length > 0 && searchQuery !== "") {
            newOptions = Object.keys(newOptions)
                .filter((groupOption) => {
                    const baskets = newOptions[groupOption];
                    return baskets.find((basket) => basket.name.toLowerCase().includes(searchQuery.toLowerCase()));
                })
                .reduce((acc, groupOption) => {
                    const baskets = newOptions[groupOption];
                    acc[groupOption] = baskets.filter((basket) => basket.name.toLowerCase().includes(searchQuery.toLowerCase()));
                    return acc;
                }, {});
        }
        if (JSON.stringify(newOptions) !== JSON.stringify(options)) setOptions(newOptions);
    }, [searchQuery, dataElements, initialOptions]);

    const clickHandleOutside = (event) => {
        if (isOpenFilter && ref.current && !ref.current.contains(event.target)) {
            document.removeEventListener("mousedown", clickHandleOutside);
            setOpenFilter(false);
        }
    };

    const handleClick = () => {
        setOpenFilter(!isOpenFilter);
    };

    const handleClear = () => {
        setSearchQuery("");
        const clearedOptions = { ...initialOptions };
        Object.keys(clearedOptions).forEach((group) => {
            clearedOptions[group] = clearedOptions[group].map((item) => ({ ...item, checked: false }));
        });
        setInitialOptions(clearedOptions);
        onClear();
        setOpenFilter(false);
    };

    const handleApply = () => {
        const selectedBaskets = Object.values(initialOptions).reduce((acc, baskets) => {
            return [...acc, ...baskets.filter((basket) => basket.checked)];
        }, []);
        onSelect(selectedBaskets);
        setOpenFilter(false);
    };

    return (
        <div ref={ref} className="custom-filter-container filter-menu-component">
            <ButtonFilter onClick={handleClick} isActive={selectedElements?.length > 0} title={"Basket"} />
            {isOpenFilter && (
                <div className="custom-filter-dropdown">
                    <div className="custom-filter-search">
                        <input type="text" autoFocus className="custom-filter-search-input" placeholder="Search ..." onChange={(e) => setSearchQuery(e.target.value)} value={searchQuery || ""} />
                        {searchQuery && (
                            <button onClick={() => setSearchQuery("")} className="custom-filter-search-clear-button">
                                &#x2715; {/* Unicode 'X' symbol */}
                            </button>
                        )}
                    </div>
                    <section className="custom-filter-items-container">
                        {Object.keys(options).length <= 0 ? (
                            <div className="custom-filter-no-data">No results found</div>
                        ) : (
                            Object.keys(options)?.map((groupOption) => (
                                <React.Fragment key={groupOption}>
                                    {/* Simple group header without click handler */}
                                    <span className="filter-menu-group-header">
                                        <span className="filter-menu-group-title">{groupOption}</span>
                                        {/* Remove collapse icon */}
                                    </span>
                                    {/* Always render group items - no conditional */}
                                    <ul className="flex flex-col gap-1">
                                        {options[groupOption]?.map((item) => (
                                            <div key={item.id} className="gd-checkbox gd-checkbox-custom">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        id={`basket-option-${item.id}`}
                                                        name="basket"
                                                        value={item.id}
                                                        checked={initialOptions[groupOption]?.find((opt) => opt.id === item.id)?.checked || false}
                                                        onChange={() => {
                                                            const tmpIndex = initialOptions[groupOption].findIndex((opt) => opt.id === item.id);
                                                            if (tmpIndex !== -1) {
                                                                initialOptions[groupOption][tmpIndex].checked = !initialOptions[groupOption][tmpIndex].checked;
                                                                setInitialOptions({ ...initialOptions });
                                                            }
                                                        }}
                                                    />
                                                    <span className="input-label-text">{item[dataLabelProp]}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </ul>
                                </React.Fragment>
                            ))
                        )}
                    </section>
                    <div className="custom-filter-actions">
                        <div className="custom-filter-status" title={selectedElements.length > 0 ? selectedElements.map((basket) => basket.name).join(", ") : "None selected"}>
                            {selectedElements.length === 0
                                ? "None"
                                : selectedElements.length <= 3
                                ? selectedElements.map((basket) => basket.name).join(", ")
                                : `${selectedElements
                                      .slice(0, 3)
                                      .map((basket) => basket.name)
                                      .join(", ")}... (${selectedElements.length})`}
                        </div>
                        <div className="custom-filter-button-group">
                            <button type="button" onClick={handleClear} className="custom-filter-button-clear">
                                Clear
                            </button>
                            <button type="button" onClick={handleApply} className="custom-filter-button-apply">
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export { FilterMenu };
